module.exports = __webpack_public_path__ + "img/milestone__1968.29f5fc5b.jpg";